import { render, staticRenderFns } from "./inspectionAreasPreset.vue?vue&type=template&id=273524e2"
import script from "./inspectionAreasPreset.vue?vue&type=script&lang=js"
export * from "./inspectionAreasPreset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports